import { useQuery } from 'react-query';
import { getSystemInstanceInfo } from '../index';
// Без trackPromise: это фоновый запрос шапки, глобальный лоадер на весь экран для него не нужен.
// Данные не меняются в течение сессии, поэтому кэш не сбрасываем и не перезапрашиваем при фокусе.
export const useGetSystemInstanceInfo = (enabled) => useQuery('SystemInstanceInfo', getSystemInstanceInfo, {
    enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
});
